module.exports = __webpack_public_path__ + "static/img/bussinessImg1.d54a3e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bussinessImg1.jpg
// module id = kCcw
// module chunks = 1